import gql from 'graphql-tag';

const MODIFY_PRODUCT = gql`
    mutation modifyProduct( $orderId: String, $ean: String, $comment: String, $sellingPrice: Int, $quantity: Int, $email: String) {
        modifyProduct(
        orderId: $orderId
        ean: $ean
        comment: $comment
        sellingPrice: $sellingPrice
        quantity: $quantity
        email: $email
        ) {
            internalCode
            message
        }
    }
`;

export default MODIFY_PRODUCT;
